var map = {
	"./pr-1.png": "d63f",
	"./pr-2.png": "4df9",
	"./pr-3.png": "f1fc",
	"./pr-4.png": "f403",
	"./pr-5.png": "a478",
	"./pr-6.png": "b226",
	"./pr-7.png": "f21b",
	"./pr-8.png": "ed9d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "05f8";